import React from 'react';
import { theme } from '../../styles/theme';

const Container = ({
  children,
  maxWidth = '1280px',
  padding = 'md',
  center = true,
  fullHeight = false,
  style = {},
  ...props
}) => {
  const paddingValues = {
    none: '0',
    sm: theme.spacing.md,
    md: theme.spacing.lg,
    lg: theme.spacing.xl,
    xl: theme.spacing.xxl,
  };

  const containerStyles = {
    maxWidth: maxWidth,
    margin: center ? '0 auto' : '0',
    padding: `0 ${paddingValues[padding]}`,
    width: '100%',
    minHeight: fullHeight ? '100vh' : 'auto',
    ...style,
  };

  // Responsive padding for mobile
  const responsiveStyles = `
    @media (max-width: ${theme.breakpoints.sm}) {
      padding-left: ${theme.spacing.md};
      padding-right: ${theme.spacing.md};
    }
  `;

  return (
    <>
      <style>{`
        .container-responsive {
          ${responsiveStyles}
        }
      `}</style>
      <div 
        className="container-responsive"
        style={containerStyles} 
        {...props}
      >
        {children}
      </div>
    </>
  );
};

export default Container;

